import { DATA_BASE_URL } from '@lib/constants';

const MediaCoverageSection = () => {
  const mediaArticles = [
    {
      title: 'Philippine and Mongolia Win Intercontinental Championship for Prisoners',
      source: 'FIDE (World Chess Federation)',
      date: '2021',
      description: 'International recognition of the prison chess program where Filipino inmates I coached competed against 46 countries.',
      link: 'https://www.fide.com/philippines-and-mongolia-win-intercontinental-championship-for-prisoners/',
      type: 'international',
    },
    {
      title: 'Senate Resolution Congratulating Prison Chess Team',
      source: 'Philippine Senate',
      date: '2021',
      description: 'Official Senate document recognizing the achievement of prisoners and their coaches in the intercontinental tournament.',
      link: 'https://legacy.senate.gov.ph/lisdata/3974036050!.pdf',
      type: 'government',
    },
    {
      title: 'Teaching Chess to Prisoners',
      source: 'Facebook Media Coverage',
      date: '2022',
      description: 'Media feature highlighting my work teaching chess to incarcerated individuals in the Philippines.',
      link: 'https://www.facebook.com/share/p/16j2tVGTHk/',
      type: 'social',
    },
    {
      title: 'National Amateur Chess Championships 2024',
      source: 'Philippine Star',
      date: 'October 2024',
      description: 'Coverage of my role in organizing and fundraising for the National Amateur Chess Championships.',
      link: 'https://www.philstar.com/sports/2024/10/03/2389855/philippine-amateur-chess-championships-slated-weekend',
      type: 'tournament',
    },
    {
      title: 'National Amateur Championship ChessFest in Tagaytay',
      source: 'BusinessWorld',
      date: 'September 2023',
      description: 'Feature on the National Amateur Championship organized with my fundraising efforts.',
      link: 'https://www.bworldonline.com/editors-picks/2023/09/17/546069/national-amateur-championship-chessfest-unfolds-in-tagaytay-city/',
      type: 'tournament',
    },
    {
      title: 'P100K National Amateur Chess Championships',
      source: 'Abante News',
      date: 'September 2023',
      description: 'Coverage of the P100,000 prize tournament organized with my support.',
      link: 'https://www.abante.com.ph/2023/09/17/p100k-natl-amateur-chess-championships-sa-tagaytay/',
      type: 'tournament',
    },
  ];

  const getTypeColor = (type) => {
    switch (type) {
      case 'international':
        return 'var(--color-accent-6)';
      case 'government':
        return 'var(--color-accent-5)';
      case 'social':
        return 'var(--color-accent-7)';
      case 'tournament':
        return 'var(--color-accent-4)';
      default:
        return 'var(--color-accent-6)';
    }
  };

  const getTypeBadge = (type) => {
    switch (type) {
      case 'international':
        return 'International';
      case 'government':
        return 'Government';
      case 'social':
        return 'Media';
      case 'tournament':
        return 'Tournament';
      default:
        return 'News';
    }
  };

  return (
    <section
      className="py-16 md:py-24"
      style={{ backgroundColor: 'var(--color-theme-1)' }}
    >
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: 'var(--color-heading)' }}
          >
            Media Recognition
          </h2>
          <p
            className="text-lg md:text-xl leading-relaxed"
            style={{ color: 'var(--color-subheading)' }}
          >
            International and national coverage of chess for social good initiatives
          </p>
        </div>

        {/* PDF Documents Highlight */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 max-w-4xl mx-auto">
          <a
            href={`${DATA_BASE_URL}/data/social_impact/media/fide_news_sept_2022_prisoner_chess.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="block group"
          >
            <div
              className="p-6 rounded-lg transition-all duration-200 h-full"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)',
                borderWidth: '2px',
                borderStyle: 'solid',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-accent-5)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-card-border)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div className="flex items-start gap-4">
                {/* PDF Icon */}
                <div
                  className="w-16 h-16 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'var(--color-accent-2)' }}
                >
                  <svg
                    className="w-8 h-8"
                    style={{ color: 'var(--color-accent-7)' }}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M4 18h12V6h-4V2H4v16zm-2 1V0h12l4 4v16H2v-1z" />
                  </svg>
                </div>

                <div className="flex-1">
                  <div
                    className="text-xs font-semibold mb-2 inline-block px-2 py-1 rounded"
                    style={{
                      backgroundColor: 'var(--color-accent-2)',
                      color: 'var(--color-accent-8)',
                    }}
                  >
                    FIDE NEWS
                  </div>
                  <h3
                    className="text-xl font-semibold mb-2"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    Prisoner Chess Initiative - September 2022
                  </h3>
                  <p
                    className="text-sm mb-3"
                    style={{ color: 'var(--color-card-text)' }}
                  >
                    Official FIDE coverage of the prison chess program
                  </p>
                  <span
                    className="text-sm font-medium"
                    style={{ color: 'var(--color-accent-6)' }}
                  >
                    Read Full Article →
                  </span>
                </div>
              </div>
            </div>
          </a>

          <a
            href={`${DATA_BASE_URL}/data/social_impact/media/philippine_inmates_checkmate_46_countries.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="block group"
          >
            <div
              className="p-6 rounded-lg transition-all duration-200 h-full"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)',
                borderWidth: '2px',
                borderStyle: 'solid',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-accent-5)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--color-card-border)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div className="flex items-start gap-4">
                {/* PDF Icon */}
                <div
                  className="w-16 h-16 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'var(--color-accent-2)' }}
                >
                  <svg
                    className="w-8 h-8"
                    style={{ color: 'var(--color-accent-7)' }}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M4 18h12V6h-4V2H4v16zm-2 1V0h12l4 4v16H2v-1z" />
                  </svg>
                </div>

                <div className="flex-1">
                  <div
                    className="text-xs font-semibold mb-2 inline-block px-2 py-1 rounded"
                    style={{
                      backgroundColor: 'var(--color-accent-2)',
                      color: 'var(--color-accent-8)',
                    }}
                  >
                    FEATURE STORY
                  </div>
                  <h3
                    className="text-xl font-semibold mb-2"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    Philippine Inmates Checkmate 46 Countries
                  </h3>
                  <p
                    className="text-sm mb-3"
                    style={{ color: 'var(--color-card-text)' }}
                  >
                    In-depth story of the historic intercontinental tournament
                  </p>
                  <span
                    className="text-sm font-medium"
                    style={{ color: 'var(--color-accent-6)' }}
                  >
                    Read Full Article →
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>

        {/* Media Articles Grid */}
        {/* Desktop: Grid layout */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaArticles.map((article, index) => (
            <a
              key={index}
              href={article.link}
              target="_blank"
              rel="noopener noreferrer"
              className="block group"
            >
              <div
                className="p-6 rounded-lg transition-all duration-200 h-full flex flex-col"
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  borderColor: 'var(--color-card-border)',
                  borderWidth: '1px',
                  borderStyle: 'solid',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = getTypeColor(article.type);
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'var(--color-card-border)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                {/* Badge and Date */}
                <div className="flex items-center justify-between mb-3">
                  <span
                    className="text-xs font-semibold px-2 py-1 rounded"
                    style={{
                      backgroundColor: 'var(--color-accent-2)',
                      color: getTypeColor(article.type),
                    }}
                  >
                    {getTypeBadge(article.type)}
                  </span>
                  <span
                    className="text-xs"
                    style={{ color: 'var(--color-muted)' }}
                  >
                    {article.date}
                  </span>
                </div>

                {/* Title */}
                <h3
                  className="text-lg font-semibold mb-2 group-hover:underline"
                  style={{ color: 'var(--color-heading)' }}
                >
                  {article.title}
                </h3>

                {/* Source */}
                <p
                  className="text-sm font-medium mb-3"
                  style={{ color: 'var(--color-accent-6)' }}
                >
                  {article.source}
                </p>

                {/* Description */}
                <p
                  className="text-sm mb-4 flex-grow"
                  style={{ color: 'var(--color-card-text)' }}
                >
                  {article.description}
                </p>

                {/* Link */}
                <span
                  className="text-sm font-medium"
                  style={{ color: getTypeColor(article.type) }}
                >
                  Read Article →
                </span>
              </div>
            </a>
          ))}
        </div>
        {/* Mobile: Horizontal scroll */}
        <div className="md:hidden overflow-x-auto scrollbar-hide -mx-4 px-4">
          <div className="flex gap-4 pb-2" style={{ minWidth: 'min-content' }}>
            {mediaArticles.map((article, index) => (
              <a
                key={index}
                href={article.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block flex-shrink-0"
                style={{ width: '300px' }}
              >
                <div
                  className="p-6 rounded-lg h-full flex flex-col shadow-md"
                  style={{
                    backgroundColor: 'var(--color-card-bg)',
                    borderColor: 'var(--color-card-border)',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                  }}
                >
                  {/* Badge and Date */}
                  <div className="flex items-center justify-between mb-3">
                    <span
                      className="text-xs font-semibold px-2 py-1 rounded"
                      style={{
                        backgroundColor: 'var(--color-accent-2)',
                        color: getTypeColor(article.type),
                      }}
                    >
                      {getTypeBadge(article.type)}
                    </span>
                    <span
                      className="text-xs"
                      style={{ color: 'var(--color-muted)' }}
                    >
                      {article.date}
                    </span>
                  </div>

                  {/* Title */}
                  <h3
                    className="text-lg font-semibold mb-2"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    {article.title}
                  </h3>

                  {/* Source */}
                  <p
                    className="text-sm font-medium mb-3"
                    style={{ color: 'var(--color-accent-6)' }}
                  >
                    {article.source}
                  </p>

                  {/* Description */}
                  <p
                    className="text-sm mb-4 flex-grow"
                    style={{ color: 'var(--color-card-text)' }}
                  >
                    {article.description}
                  </p>

                  {/* Link */}
                  <span
                    className="text-sm font-medium"
                    style={{ color: getTypeColor(article.type) }}
                  >
                    Read Article →
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Media Image Preview */}
        <div className="mt-12 max-w-2xl mx-auto">
          <img
            src={`${DATA_BASE_URL}/data/social_impact/media/ph_amateur_chess_2024.webp`}
            alt="Philippine Amateur Chess Championship 2024"
            className="w-full rounded-lg shadow-lg"
          />
          <p
            className="mt-4 text-center text-sm"
            style={{ color: 'var(--color-muted)' }}
          >
            Philippine Amateur Chess Championship 2024 - Organized with my fundraising support
          </p>
        </div>
      </div>
    </section>
  );
};

export default MediaCoverageSection;
